// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-page {
  width: 100%;
  min-height: 100vh;
  background-color: white;
}

.gallery-section {
  padding: 4rem 2rem;
  background-color: #f9f9f9;
}

.gallery-section-content {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 2.5rem;
  color: #526015;
  text-align: center;
  margin-bottom: 1rem;
}

.section-description {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 3rem;
  color: #666;
  line-height: 1.6;
  font-size: 1.1rem;
}

.gallery-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.gallery-content {
  position: relative;
  width: 100%;
  height: 500px;
}

.gallery-slides {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.gallery-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.5s ease-in-out;
}

.gallery-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(39, 31, 18, 0.7);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;
}

.gallery-nav:hover {
  background: rgba(39, 31, 18, 0.9);
  transform: translateY(-50%) scale(1.1);
}

.gallery-nav:active {
  transform: translateY(-50%) scale(0.95);
}

.gallery-nav.prev {
  left: 20px;
}

.gallery-nav.next {
  right: 20px;
}

.gallery-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 2;
  padding: 10px;
  background: rgba(39, 31, 18, 0.3);
  border-radius: 20px;
  backdrop-filter: blur(4px);
}

.gallery-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;
}

.gallery-dot:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: scale(1.2);
}

.gallery-dot.active {
  background: #D4AF37;
  transform: scale(1.2);
}

/* Image Slideshow Styles */
.slideshow-container {
  position: relative;
  margin-bottom: 3rem;
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 16/9;
}

.slides {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.slide.active {
  opacity: 1;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Common Slideshow Controls */
.slide-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 2;
  transition: background-color 0.3s ease;
  border-radius: 50%;
}

.slide-btn:hover {
  background: rgba(0, 0, 0, 0.7);
}

.prev {
  left: 1rem;
}

.next {
  right: 1rem;
}

.slide-dots {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
  z-index: 2;
  padding: 0.5rem;
  border-radius: 1rem;
  background: rgba(0, 0, 0, 0.3);
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  transition: all 0.3s ease;
}

.dot.active {
  background: white;
  transform: scale(1.2);
}

/* Testimonials Styles */
.testimonials-section {
  margin-top: 2rem;
  position: relative;
}

.testimonial-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  pointer-events: none;
}

.testimonial-slide.active {
  opacity: 1;
  pointer-events: auto;
}

.testimonial-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  background: #fff;
  max-width: 600px;
  margin: 0 auto;
}

.testimonial-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.testimonial-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.testimonial-name {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-dark);
  margin: 0;
}

.testimonial-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
  margin-bottom: 1rem;
}

.testimonial-actions {
  display: flex;
  gap: 1rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;
}

.action-btn {
  background: none;
  border: none;
  color: #666;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.3s ease;
}

.action-btn:hover {
  color: var(--color-gold);
}

.testimonial-dots {
  position: static;
  margin-top: 1rem;
  visibility: hidden;
  background: none;
  justify-content: center;
}

.testimonial-dots .dot {
  width: 8px;
  height: 8px;
  background: rgba(0, 0, 0, 0.2);
}

.testimonial-dots .dot.active {
  background: var(--color-gold);
  transform: scale(1.2);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .gallery-content {
    height: 400px;
  }
}

@media (max-width: 768px) {
  .gallery-content {
    height: 300px;
  }

  .gallery-nav {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }

  .gallery-nav.prev {
    left: 10px;
  }

  .gallery-nav.next {
    right: 10px;
  }

  .gallery-dots {
    bottom: 15px;
    gap: 8px;
    padding: 8px;
  }

  .gallery-dot {
    width: 8px;
    height: 8px;
  }

  .gallery-section {
    padding: 3rem 1.5rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-description {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .slideshow-container {
    margin-bottom: 2rem;
  }

  .slide-btn {
    width: 32px;
    height: 32px;
    font-size: 1.2rem;
  }

  .testimonial-card {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .gallery-container {
    border-radius: 8px;
  }

  .gallery-content {
    height: 250px;
  }

  .gallery-nav {
    width: 32px;
    height: 32px;
    font-size: 18px;
    opacity: 0.8;
  }

  .gallery-nav.prev {
    left: 8px;
  }

  .gallery-nav.next {
    right: 8px;
  }

  .gallery-dots {
    bottom: 10px;
    gap: 6px;
    padding: 6px;
  }

  .gallery-dot {
    width: 6px;
    height: 6px;
  }

  .gallery-section {
    padding: 2rem 1rem;
  }

  .section-title {
    font-size: 1.75rem;
  }
}

/* Touch device optimizations */
@media (hover: none) {
  .gallery-nav {
    opacity: 0.8;
  }

  .gallery-nav:hover {
    transform: translateY(-50%);
    background: rgba(39, 31, 18, 0.7);
  }

  .gallery-dot:hover {
    transform: none;
    background: rgba(255, 255, 255, 0.5);
  }

  .gallery-dot.active {
    transform: scale(1.2);
    background: #D4AF37;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/GalleryComponent.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,UAAU;EACV,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,WAAW;EACX,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,oCAAoC;EACtC;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;AACF","sourcesContent":[".gallery-page {\n  width: 100%;\n  min-height: 100vh;\n  background-color: white;\n}\n\n.gallery-section {\n  padding: 4rem 2rem;\n  background-color: #f9f9f9;\n}\n\n.gallery-section-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-title {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 2.5rem;\n  color: #526015;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.section-description {\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  color: #666;\n  line-height: 1.6;\n  font-size: 1.1rem;\n}\n\n.gallery-container {\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.gallery-content {\n  position: relative;\n  width: 100%;\n  height: 500px;\n}\n\n.gallery-slides {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.gallery-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.gallery-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(39, 31, 18, 0.7);\n  color: white;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  transition: all 0.3s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.gallery-nav:hover {\n  background: rgba(39, 31, 18, 0.9);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.gallery-nav:active {\n  transform: translateY(-50%) scale(0.95);\n}\n\n.gallery-nav.prev {\n  left: 20px;\n}\n\n.gallery-nav.next {\n  right: 20px;\n}\n\n.gallery-dots {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 10px;\n  z-index: 2;\n  padding: 10px;\n  background: rgba(39, 31, 18, 0.3);\n  border-radius: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.gallery-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  transition: all 0.3s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.gallery-dot:hover {\n  background: rgba(255, 255, 255, 0.8);\n  transform: scale(1.2);\n}\n\n.gallery-dot.active {\n  background: #D4AF37;\n  transform: scale(1.2);\n}\n\n/* Image Slideshow Styles */\n.slideshow-container {\n  position: relative;\n  margin-bottom: 3rem;\n  border-radius: 8px;\n  overflow: hidden;\n  aspect-ratio: 16/9;\n}\n\n.slides {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.slide.active {\n  opacity: 1;\n}\n\n.slide-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Common Slideshow Controls */\n.slide-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 1.5rem;\n  z-index: 2;\n  transition: background-color 0.3s ease;\n  border-radius: 50%;\n}\n\n.slide-btn:hover {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.prev {\n  left: 1rem;\n}\n\n.next {\n  right: 1rem;\n}\n\n.slide-dots {\n  position: absolute;\n  bottom: 1rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 0.5rem;\n  z-index: 2;\n  padding: 0.5rem;\n  border-radius: 1rem;\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  transition: all 0.3s ease;\n}\n\n.dot.active {\n  background: white;\n  transform: scale(1.2);\n}\n\n/* Testimonials Styles */\n.testimonials-section {\n  margin-top: 2rem;\n  position: relative;\n}\n\n.testimonial-slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n  pointer-events: none;\n}\n\n.testimonial-slide.active {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.testimonial-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  background: #fff;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.testimonial-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.testimonial-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.testimonial-name {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-dark);\n  margin: 0;\n}\n\n.testimonial-content {\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #444;\n  margin-bottom: 1rem;\n}\n\n.testimonial-actions {\n  display: flex;\n  gap: 1rem;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 1rem;\n}\n\n.action-btn {\n  background: none;\n  border: none;\n  color: #666;\n  font-size: 0.9rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n.action-btn:hover {\n  color: var(--color-gold);\n}\n\n.testimonial-dots {\n  position: static;\n  margin-top: 1rem;\n  visibility: hidden;\n  background: none;\n  justify-content: center;\n}\n\n.testimonial-dots .dot {\n  width: 8px;\n  height: 8px;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.testimonial-dots .dot.active {\n  background: var(--color-gold);\n  transform: scale(1.2);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .gallery-content {\n    height: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .gallery-content {\n    height: 300px;\n  }\n\n  .gallery-nav {\n    width: 36px;\n    height: 36px;\n    font-size: 20px;\n  }\n\n  .gallery-nav.prev {\n    left: 10px;\n  }\n\n  .gallery-nav.next {\n    right: 10px;\n  }\n\n  .gallery-dots {\n    bottom: 15px;\n    gap: 8px;\n    padding: 8px;\n  }\n\n  .gallery-dot {\n    width: 8px;\n    height: 8px;\n  }\n\n  .gallery-section {\n    padding: 3rem 1.5rem;\n  }\n\n  .section-title {\n    font-size: 2rem;\n  }\n\n  .section-description {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .slideshow-container {\n    margin-bottom: 2rem;\n  }\n\n  .slide-btn {\n    width: 32px;\n    height: 32px;\n    font-size: 1.2rem;\n  }\n\n  .testimonial-card {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-container {\n    border-radius: 8px;\n  }\n\n  .gallery-content {\n    height: 250px;\n  }\n\n  .gallery-nav {\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n    opacity: 0.8;\n  }\n\n  .gallery-nav.prev {\n    left: 8px;\n  }\n\n  .gallery-nav.next {\n    right: 8px;\n  }\n\n  .gallery-dots {\n    bottom: 10px;\n    gap: 6px;\n    padding: 6px;\n  }\n\n  .gallery-dot {\n    width: 6px;\n    height: 6px;\n  }\n\n  .gallery-section {\n    padding: 2rem 1rem;\n  }\n\n  .section-title {\n    font-size: 1.75rem;\n  }\n}\n\n/* Touch device optimizations */\n@media (hover: none) {\n  .gallery-nav {\n    opacity: 0.8;\n  }\n\n  .gallery-nav:hover {\n    transform: translateY(-50%);\n    background: rgba(39, 31, 18, 0.7);\n  }\n\n  .gallery-dot:hover {\n    transform: none;\n    background: rgba(255, 255, 255, 0.5);\n  }\n\n  .gallery-dot.active {\n    transform: scale(1.2);\n    background: #D4AF37;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
